import { CSSObject } from "@emotion/react";
import { constants, typographyStyles } from "@newsela/angelou";

const { heading4Obj, textMObj } = typographyStyles;
const grey = constants.colors.ui.neutral[500];

export const rootCss: CSSObject = {
  width: "100%",
  margin: "24px 0",
};

export const containerCss: CSSObject = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
};

export const headingCss: CSSObject = {
  ...heading4Obj,
  display: "flex",
  fontWeight: "bold",
  marginBottom: "16px",
};

export const headingTextCss: CSSObject = {
  marginRight: "16px",
};

export const iconCss: CSSObject = {
  width: 24,
  height: 24,
};

export const responseTextCss: CSSObject = {
  ...textMObj,
  margin: 0,
  textAlign: "left",
  color: grey,
};
